import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import * as api from '../services/api'

const useSearchStore = create(
  persist(
    (set, get) => ({
      // State
      isOpen: false,
      query: '',
      results: [],
      isLoading: false,
      totalCount: 0,
      recentSearches: [],

      // Actions
      setOpen: (isOpen) => {
        set({ isOpen })
        if (!isOpen) {
          // Clear search state when closing
          set({ query: '', results: [], isLoading: false, totalCount: 0 })
        }
      },

      setQuery: (query) => {
        set({ query })
      },

      search: async (query) => {
        if (!query || query.length < 2) {
          set({ results: [], totalCount: 0, isLoading: false })
          return
        }

        set({ isLoading: true })
        try {
          const response = await api.searchTasks(query)
          set({
            results: response.results || [],
            totalCount: response.totalCount || 0,
            isLoading: false
          })
        } catch (error) {
          console.error('Search failed:', error)
          set({ results: [], totalCount: 0, isLoading: false })
        }
      },

      clearSearch: () => {
        set({ query: '', results: [], totalCount: 0, isLoading: false })
      },

      close: () => {
        set({
          isOpen: false,
          query: '',
          results: [],
          totalCount: 0,
          isLoading: false
        })
      },

      addRecentSearch: (query) => {
        if (!query || query.length < 2) return

        const { recentSearches } = get()
        // Remove duplicate if exists, then add to front
        const filtered = recentSearches.filter(s => s !== query)
        const updated = [query, ...filtered].slice(0, 5) // Keep max 5
        set({ recentSearches: updated })
      }
    }),
    {
      name: 'search-storage',
      // Only persist recentSearches
      partialize: (state) => ({ recentSearches: state.recentSearches })
    }
  )
)

export default useSearchStore
